import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_STATE } from '../state';
import * as reducers from './reducers';

const commonSlice = createSlice({
    name: 'common',
    initialState: INITIAL_STATE,
    reducers: { ...reducers }
});

export default commonSlice.reducer;
export const {
    changeName,
    changeEMail,
    changeDetails,
    clearContact
} = commonSlice.actions;
